module.exports = __webpack_public_path__ + "e64b7aa43e174a5ace6a4e47dba57142.svg";